export const environment = {
  production: true,
  apiVersion: '2.3',
  version: ''
};
